import { useMemo } from "react";
import { object, array, TestContext, ValidationError } from "yup";
import { FormField, type ClientDocument } from "./types";
import {
    assertDocumentRequired,
    assertDocumentSize,
    assertDocumentType
} from "./assertions";

const useValidationSchema = () =>
    useMemo(() => (
        object().shape({
            [FormField.BankReference]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Bank Reference Document'),

            [FormField.CopyOfLicences]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Copy of Licences Document'),

            [FormField.ProofOfDomainOwnership]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Proof of Domain Ownership Document'),

            [FormField.StructureChart]: array()
                .test('documents', 'Invalid document', validateOptionalDocuments)
                .label('Structure Chart Document'),

            [FormField.CertificateOfIncorporation]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Certificate of Incorporation Document'),

            [FormField.MemorandumAndArticles]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Memorandum and Articles Document'),

            [FormField.CompanyAccountBankStatement]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Company Account Bank Statement Document'),

            [FormField.CompanyFinancialStatement]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Company Financial Statement Document'),

            [FormField.OfficialCompanyDocWithAuthority]: array()
                .test('documents', 'Invalid document', validateRequiredDocuments)
                .label('Official Company Document with Authority Document')
        })
    ), []);

export default useValidationSchema;

function validateOptionalDocuments(this: TestContext, files: Array<ClientDocument> = []) {
    try {
        assertDocumentSize.call(this, files);
        assertDocumentType.call(this, files);

        return true;
    }catch (error) {
        if (error instanceof ValidationError) {
            return error;
        }

        throw error;
    }
}

function validateRequiredDocuments(this: TestContext, files: Array<ClientDocument> = []) {
    try {
        assertDocumentRequired.call(this, files);
        assertDocumentSize.call(this, files);
        assertDocumentType.call(this, files);

        return true;
    }catch (error) {
        if (error instanceof ValidationError) {
            return error;
        }

        throw error;
    }
}
